<template lang="pug">
  div.form-the-press
      h3 FROM THE PRESS
      div.press-list
        each val in [1, 2, 3, 4, 5, 6, 7, 8]
          section.source
            figure
              img(src="https://s3-us-west-1.amazonaws.com/stance.media/media/pages/about/press-logos/buzzfeed.svg?mtime=20170223102022", alt="", title="")
            p.introduce
              small "This company may have just created the most comfortable men's underwear. Comfort, odor resistance, and a new type of 'milk' fabric all-in-one."
</template>
<script>
export default {
  name: 'FromThePress'
}
</script>
<style lang="scss" scoped>
.form-the-press {
  padding: 0 15px;
}
section {
  padding:  0 15px;
  margin-bottom: 1.25rem;
}

section:nth-child(n+4) {
  display: none;
}
h3 {
  font-family: akzidenz-grotesk-condensed;
  font-weight: 400;
  line-height: 1.1;
  color: #1a1a1a;
  text-align: center;
  font-size: 2.29rem;
}
.form-the-press {
  figure {
    width: 100%;
    text-align: center;
  }
  img {
    max-width: 100%;
    width: 50%;
  }
  p {
    text-align: center;
  }
}

@media only screen and (min-width: 768px) {
  .form-the-press  {
    max-width: 80rem;
    margin: 0 auto;
    .press-list {
      display: flex;
      flex-flow: row wrap;
    }

    img {
      width: 100%;
    }

    section {
      width: 25%;
    }
    section:nth-child(n+4) {
      display: block;
    }
  }
}
</style>
